import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, normalizeStyle as _normalizeStyle, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/area/horizontal-blur.png'
import _imports_1 from '@/assets/icon-warning.svg'


const _withScopeId = n => (_pushScopeId("data-v-ae68bf08"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "content-download-railway-comparison",
  class: "jr-w-full jr-overflow-scroll jr-pb-36"
}
const _hoisted_2 = { class: "jr-py-1 jr-mb-2" }
const _hoisted_3 = { class: "jr-px-7.5 jr-border-l jr-border-dashed jr-border-blue-light-soft" }
const _hoisted_4 = { class: "jr-flex jr-items-center" }
const _hoisted_5 = { class: "jr-mr-8 jr-text-base jr-font-medium jr-text-primary" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "jr-inline-block jr-text-s" }, "駅周辺移動元・先エリア分布", -1))
const _hoisted_7 = { class: "jr-relative" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "jr-absolute jr-max-h-full jr-right-0 jr-top-0",
  src: _imports_0,
  alt: "blur"
}, null, -1))
const _hoisted_9 = { class: "jr-flex jr-justify-center" }
const _hoisted_10 = { class: "jr-flex jr-flex-col jr-items-center jr-justify-center jr-text-xl jr-text-primary jr-font-bold jr-mt-15" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "jr-mb-5.5",
  src: _imports_1,
  alt: "icon-warning"
}, null, -1))
const _hoisted_12 = { class: "chart-container jr-w-full jr-mr-13" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RailwayFilterBadge = _resolveComponent("RailwayFilterBadge")!
  const _component_PolygonColors = _resolveComponent("PolygonColors")!
  const _component_UIGoogleMap = _resolveComponent("UIGoogleMap")!
  const _component_ComparisonBarchart = _resolveComponent("ComparisonBarchart")!
  const _component_AttributeBarchart = _resolveComponent("AttributeBarchart")!
  const _component_RailwaySearchFilter = _resolveComponent("RailwaySearchFilter")!
  const _component_AppLoader = _resolveComponent("AppLoader")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["jr-flex jr-fixed jr-w-full", { 'jr-h-full': !_ctx.captureClip && !_ctx.isCapturing, 'jr-mt-28': !_ctx.isCapturing, 'jr-mt-18': _ctx.isCapturing }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _withDirectives(_createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("h1", _hoisted_5, _toDisplayString(_ctx.selectedRailwayLine) + " (" + _toDisplayString(_ctx.selectedRailwayStation) + ")", 1),
            _hoisted_6
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", {
              class: _normalizeClass([{ 'badge-contents': !_ctx.isCapturing }, "jr-flex jr-mt-1.5 jr-overflow-x-auto"])
            }, [
              _createVNode(_component_RailwayFilterBadge, {
                class: "badge-box",
                data: _ctx.railwayTimeRange
              }, null, 8, ["data"]),
              _createVNode(_component_RailwayFilterBadge, {
                class: "badge-box",
                data: _ctx.railwayWeek
              }, null, 8, ["data"])
            ], 2),
            _hoisted_8
          ])
        ])
      ], 512), [
        [_vShow, _ctx.captureClip]
      ]),
      _createVNode(_component_UIGoogleMap, {
        class: "map jr-relative",
        right: _ctx.captureClip ? 18 : _ctx.filterMinimum ? 72 : 302,
        onLoad: _ctx.handleMapLoad
      }, {
        default: _withCtx(() => [
          _createVNode(_component_PolygonColors, {
            class: "transition-indicator jr-absolute jr-bottom-3.5",
            style: _normalizeStyle({ left: _ctx.captureClip ? '10px' : _ctx.sbMinimum ? '74px' : '250px' })
          }, null, 8, ["style"])
        ]),
        _: 1
      }, 8, ["right", "onLoad"]),
      _createElementVNode("div", _hoisted_9, [
        _withDirectives(_createElementVNode("div", _hoisted_10, [
          _hoisted_11,
          _createElementVNode("span", null, _toDisplayString(_ctx.lessAmountMessage), 1)
        ], 512), [
          [_vShow, _ctx.isLess]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_12, [
          _createVNode(_component_ComparisonBarchart, { class: "jr-mt-7.5" }),
          _createVNode(_component_AttributeBarchart, {
            class: "jr-mt-6.5",
            data: _ctx.attribute
          }, null, 8, ["data"])
        ], 512), [
          [_vShow, !_ctx.isLess]
        ])
      ])
    ]),
    _createVNode(_component_RailwaySearchFilter, {
      onResize: _ctx.handleFilterResize,
      onSearch: _ctx.handleSearch
    }, null, 8, ["onResize", "onSearch"]),
    (_ctx.isLoading)
      ? (_openBlock(), _createBlock(_component_AppLoader, { key: 0 }))
      : _createCommentVNode("", true)
  ], 2))
}